import React, { useState, useCallback, useRef } from 'react';
import styled from 'styled-components';

const BOUNCE_FIXED_ENABLED = false;

const BounceFix = (props) => {
  if (BOUNCE_FIXED_ENABLED) return <BounceFixImpl {...props} />;
  return props.children;
};

const BounceFixImpl = (props) => {
  const divRef = useRef(null);
  const [blockTouchMove, setBlockTouchMove] = useState(false);

  const onTouchStart = useCallback(e => {
    const el = divRef.current;
    if (el == null) return;
    const isScrollable = el.scrollHeight > el.offsetHeight;
    // If scrollable, adjust
    if (isScrollable) {
      setBlockTouchMove(false);
      // Scroll to end.
      const curPos = el.scrollTop;
      const height = el.offsetHeight;
      const scroll = el.scrollHeight;
      // If at top, bump down 1px
      if (curPos <= 0) {
        el.scrollTop = 1;
      }
      // If at bottom, bump up 1px
      if (curPos + height >= scroll) {
        el.scrollTop = scroll - height - 1;
      }
    } else {
      // Else block touchmove
      setBlockTouchMove(true);
    }
  }, [divRef]);

  const onTouchMove = useCallback(e => {
    if (blockTouchMove) {
      e.preventDefault();
    }
  }, [blockTouchMove]);

  const onTouchEnd = useCallback(e => {
    setBlockTouchMove(false);
  }, []);

  return (
    <BounceFixContainer {...props} onTouchStart={onTouchStart} onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd} onTouchCancel={onTouchEnd} ref={divRef}>
      {props.children}
    </BounceFixContainer>
  );
};

const BounceFixContainer = styled.div`
/* The lib originally asks to apply these, but it works without them, so why bother? */
/*
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
*/
`;

export default BounceFix;
